import { Icon3d3d, Icon3dCycle, Icon3dDetect, Icon3dMeter } from '@assets/images/icon';
import { cameraBannerBg } from '@assets/images/main/camera';
import { IconGpsDeviceOff, IconGpsDeviceOn, IconGpsTagOff, IconGpsTagOn, IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import { loraGatewayOn, loraGatewayOff, loraSensorOn, loraSensorOff, airOn, airOff, coOn, coOff, IconAlarm } from '@assets/images/main/index';
import { outdoorBannerImg } from '@assets/images/main/outdoor';

export default {
  banner: {
    title: 'Dù là không gian rộng lớn hay tài sản di chuyển,<br/>mọi thứ đều đơn giản trên giao diện ORBRO.',
    desc: 'Theo dõi chuyển động của phương tiện, tài sản và thiết bị bằng GPS,<br/>và đồng bộ hóa dữ liệu vị trí thời gian thực vào ORBRO OS thông qua LTE và bộ thu LoRA.',
    schemeTitle: 'Hãy khám phá giải pháp theo dõi vị trí ngoài trời phù hợp với bạn',
    bgImg: cameraBannerBg,
    productImg: outdoorBannerImg,
  },

  bannerData: [
    {
      icon: IconGpsDeviceOn,
      iconInv: IconGpsDeviceOff,
      image: '',
      iconText: 'Thiết bị GPS',
      sub: 'New',
      link: '/vi/outdoor/gps',
    },
    {
      icon: IconGpsTagOn,
      iconInv: IconGpsTagOff,
      image: '',
      iconText: 'Thẻ GPS (LoRA)',
      sub: 'New',
      link: '/vi/outdoor/lora',
    },
  ],

  func: {
    title: 'Khám phá chức năng camera',
    desc: 'Tìm hiểu các chức năng đa dạng của camera.',

    data: [
      {
        img: IconBlueShield,
        title: 'Theo dõi lộ trình di chuyển theo thời gian thực',
        desc: 'Hiển thị trực quan trên bản đồ lộ trình di chuyển của các tài sản ngoài trời như xe cộ, thiết bị, container,… để nắm bắt dễ dàng vị trí hiện tại và lịch sử di chuyển trước đó.',
      },
      {
        img: IconAlarm,
        title: 'Thiết lập khu vực và phát hiện vi phạm ranh giới',
        desc: 'Có thể định nghĩa trước các khu vực cụ thể như cảng biển, bãi tập kết, khu vực thi công,… và hệ thống sẽ tự động gửi cảnh báo khi tài sản ra/vào các khu vực này.',
      },
      {
        img: Icon3dMeter,
        title: 'Phân tích thời gian vận hành thiết bị',
        desc: 'Dựa trên dữ liệu GPS, hệ thống tự động phân loại thời gian vận hành/đợi/dừng của phương tiện hoặc thiết bị hạng nặng để phân tích tỷ lệ hoạt động và mức độ sử dụng thiết bị.',
      },
      {
        img: Icon3dCycle,
        title: 'Phát hiện và cảnh báo khi vượt tốc độ',
        desc: 'Khi vượt ngưỡng tốc độ đã thiết lập hoặc xảy ra các chuyển động bất thường so với mẫu di chuyển dự kiến, hệ thống sẽ tự động gửi cảnh báo đến người quản trị.',
      },
      {
        img: Icon3dDetect,
        title: 'Giám sát trạng thái thiết bị GPS từ xa',
        desc: 'Có thể kiểm tra từ xa qua máy chủ các thông tin như mức pin còn lại, thời điểm liên lạc cuối cùng, tần suất cập nhật vị trí,… và cảnh báo sẽ được đưa ra nếu phát hiện bất thường.',
      },
      {
        img: Icon3d3d,
        title: 'Tự động tạo báo cáo theo tài sản',
        desc: 'Tự động tạo các báo cáo vận hành theo ngày/tuần/tháng dựa trên lịch sử vị trí, khu vực lưu trú, quãng đường di chuyển, nhật ký ra vào khu vực,… của từng tài sản.',
      },
    ],
  },

  FAQ: [
    {
      title: 'Hệ thống định vị GPS của ORBRO hoạt động như thế nào?',
      description:
        'Thiết bị đầu cuối thu tín hiệu GNSS (GPS) sẽ tính toán vị trí của tài sản ngoài trời theo thời gian thực và truyền dữ liệu này đến máy chủ ORBRO thông qua mạng LoRa hoặc LTE-M. Vị trí nhận được sẽ được hiển thị trực quan trên bản đồ thông qua ORBRO OS.',
    },
    {
      title: 'Bộ thu LoRa đóng vai trò gì?',
      description:
        'Bộ thu LoRa có nhiệm vụ tiếp nhận tín hiệu được truyền từ thiết bị GPS và truyền dữ liệu này đến máy chủ ORBRO thông qua kết nối có dây (PoE). Việc lắp đặt các bộ thu này tại những khu vực rộng giúp hệ thống nhận dữ liệu vị trí theo thời gian thực.',
    },
    {
      title: 'Có thể sử dụng ở khu vực ngoài trời không có nguồn điện không?',
      description:
        'Thiết bị GPS có thể hoạt động tối đa 150 ngày nhờ pin tích hợp, nên vẫn có thể sử dụng ở những nơi không có hạ tầng điện. Tuy nhiên, bộ thu LoRa là thiết bị cố định sử dụng nguồn PoE nên cần có cấp nguồn để hoạt động.',
    },
    {
      title: 'Có hỗ trợ theo dõi theo thời gian thực không?',
      description:
        'Vâng, có thể. Thiết bị GPS sẽ gửi vị trí định kỳ và dữ liệu được phản ánh lên máy chủ gần như theo thời gian thực. Chu kỳ truyền có thể điều chỉnh theo cài đặt, thông thường từ 10 giây đến 1 phút.',
    },
    {
      title: 'Theo dõi bằng GPS có tốt hơn RTLS trong nhà không?',
      description:
        'Điều này sẽ tùy thuộc vào từng tình huống. GPS phù hợp tối ưu cho môi trường ngoài trời, đặc biệt là các khu vực rộng, tài sản, đối tượng theo dõi di chuyển tự do.<br/>Ngược lại, RTLS có lợi thế trong việc định vị chính xác cao trong không gian trong nhà. ORBRO hỗ trợ vận hành tích hợp cả trong nhà và ngoài trời.',
    },
    {
      title: 'Dữ liệu vị trí có được lưu lại không?',
      description:
        'Vâng. Dữ liệu vị trí thu thập được sẽ được lưu trữ trên máy chủ ORBRO và được sử dụng để phân tích lịch sử di chuyển của từng tài sản, hồ sơ ra vào, thời gian lưu trú, v.v. Tất cả dữ liệu được quản lý an toàn theo quyền truy cập và chính sách mã hóa.',
    },
    {
      title: 'Có thể kiểm tra trạng thái thiết bị không?',
      description:
        'Vâng, có thể kiểm tra từ xa mức pin, thời điểm liên lạc cuối cùng, chất lượng tín hiệu, v.v. của từng thiết bị đầu cuối trên ORBRO OS, và thông báo tự động sẽ được gửi khi phát hiện sự cố bất thường.',
    },
    {
      title: 'Có thể thiết lập cảnh báo thời gian thực không?',
      description:
        'Vâng, có thể. Nếu phát hiện tài sản, đối tượng theo dõi rời khỏi khu vực đã chỉ định, di chuyển không theo lộ trình dự kiến, hoặc vượt quá tốc độ quy định, hệ thống sẽ gửi cảnh báo theo thời gian thực cho quản trị viên (qua Push, Email, Webhook, v.v.).',
    },
  ],
};
